import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DashBoardAsync from './pages/dashboard/DashBoardAsync';
import QuizPageAsync from './pages/quizPage/QuizPageAsync';
import SettingAsync from './pages/setting/SettingAsync';
import CalendarPageAsync from './pages/calendarPage/CalendarPageAsync';
import TemplateWizard from './components/templateWizard/TemplateWizard';
import DuplicatePopup from './pages/dashboard/components/duplicatePopup/DuplicatePopup';
import Popup from '../../components/common/popUp/PopUp';
import { deleteQuiz } from '../../data/quiz/actions';
import { deleteCalendar } from '../../data/calendar/actions';
import { getProfile } from '../../data/profile/actions';
import { getAllLangs } from '../../data/langs/actions';
import styles from './manager.css';
import Tutorials from '../../pages/tutorials/Tutorials';
import { PermissionProvider } from '../../context/PermissionsContext';
import AuthenticatedRoute from '../../components/authenticatedRoute/AuthenticatedRoute';
import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer } from 'react-toastify';

//import DeleteUserDataForm  from './pages/dashboard/components/deleleUserDataForm/DeleteUserDataForm';
/**
 *
 * @type {React.NamedExoticComponent<{readonly route?: *, readonly quizType?: *}>}
 */
const MainPage =  ( { route  } ) => {
    const { profile, global:{ quizType }, localization: { content } } = useSelector( ( state ) => state );
    const dispatch = new useDispatch();
    const [ templateWizardOpened, setTemplateWizardOpened ] = useState( false );
    const [ duplicatePopupOpened, setDuplicatePopupOpened ] = useState( false );
    const [ deleteConfirmationOpened, setDeleteConfirmationOpened ] = useState( false );
    const [ deletingQuiz, setDeletingQuiz ] = useState( 0 );
    const [ deletingCalendar, setDeletingCalendar ] = useState( 0 );
    const [ deletingType, setDeletingType ] = useState( '' );
    const [ duplicatingEl, setDuplicatingEl ] = useState( null );


    useEffect( () => {
        dispatch( getProfile() );
        dispatch( getAllLangs() );
        injectStyle();
    }, [] );

    useEffect(()=>{
        const elm = document.getElementById('formilla-frame');

        if (document.location.pathname!== '/dashboard/tutorials' ){
            if( elm !== null){
                elm.style.display ='block';
            }
        } else {
            if( elm !== null){
                elm.style.display ='none';
            }
        }

    },[route]);

    const toggleTemplateWizard = () => {
        setTemplateWizardOpened( !templateWizardOpened );
    };

    const toggleDuplicatePopup = ( elID = null ) => {
        setDuplicatePopupOpened( !duplicatePopupOpened );
        setDuplicatingEl( elID );
    };

    const toggleDeleteConfirmation = ( id, type ) => {
        setDeleteConfirmationOpened( !deleteConfirmationOpened );
        setDeletingQuiz( deletingQuiz ? 0 : id );
        setDeletingCalendar( deletingCalendar ? 0 : id );
        setDeletingType( deletingType ? '' : type );
    };

    const deleteQuizHandle = () => {
        if ( deletingType === 'quiz' ) {
            dispatch( deleteQuiz( deletingQuiz ) );
        } else {
            dispatch( deleteCalendar( deletingCalendar ) );
        }

        setDeleteConfirmationOpened( false );
        setDeletingQuiz( 0 );
        setDeletingCalendar( 0 );
        setDeletingType( '' );
        setDuplicatingEl( null );
    };


    return (
        <PermissionProvider permissions={profile.permissions}>
        <div className={ styles.wrapper }>
            <ToastContainer />
            <Switch>

                <Route
                    exact
                    path='/'
                    render={ ( routeProps ) => <DashBoardAsync
                        props={ {
                            ...routeProps,
                            route: route,
                            handleOpenTemplateWizard: toggleTemplateWizard,
                            handleToggleDuplicatePopup: toggleDuplicatePopup,
                            handleDeleteConfirmationOpen: toggleDeleteConfirmation
                        } }
                    /> }>
                    <Redirect to='/dashboard/quizes'/>

                </Route>
                <Route
                    exact
                    path='/dashboard'
                    render={ ( routeProps ) =>
                        <DashBoardAsync
                            props={ {
                                ...routeProps,
                                route: route,

                                handleOpenTemplateWizard: toggleTemplateWizard,
                                handleToggleDuplicatePopup: toggleDuplicatePopup,
                                handleDeleteConfirmationOpen: toggleDeleteConfirmation
                            } }
                        />
                    }
                />
                <Route
                    exact
                    path='/dashboard/tutorials'
                    render={ ( routeProps ) =>
                        <Tutorials
                            props={ {
                                quizType: 'quiz',
                                route: route, ...routeProps,
                                handleOpenTemplateWizard: toggleTemplateWizard
                            } }
                        />
                    }
                />


                <Route
                    exact
                    path='/dashboard/quizes'
                    render={ ( routeProps ) =>
                        <DashBoardAsync
                            props={ {
                                ...routeProps,
                                route: route,

                                handleOpenTemplateWizard: toggleTemplateWizard,
                                handleToggleDuplicatePopup: toggleDuplicatePopup,
                                handleDeleteConfirmationOpen: toggleDeleteConfirmation
                            } }

                        />

                    }
                />
                <Route
                    exact
                    path='/dashboard/calendars'
                    render={ ( routeProps ) =>
                        <DashBoardAsync
                            props={ {
                                ...routeProps,
                                route: route,

                                handleOpenTemplateWizard: toggleTemplateWizard,
                                handleToggleDuplicatePopup: toggleDuplicatePopup,
                                handleDeleteConfirmationOpen: toggleDeleteConfirmation
                            } }

                        />

                    }
                />
                <Route
                    exact
                    path='/dashboard/perstests'
                    render={ ( routeProps ) =>
                        <DashBoardAsync
                            props={ {
                                ...routeProps,
                                route: route,

                                handleOpenTemplateWizard: toggleTemplateWizard,
                                handleToggleDuplicatePopup: toggleDuplicatePopup,
                                handleDeleteConfirmationOpen: toggleDeleteConfirmation
                            } }

                        />
                    }
                />

                <Route
                    exact
                    path='/dashboard/academy'
                    render={ ( routeProps ) =>
                        <DashBoardAsync
                            props={ {
                                ...routeProps,
                                route: route,
                                handleOpenTemplateWizard: toggleTemplateWizard,
                                handleToggleDuplicatePopup: toggleDuplicatePopup,
                                handleDeleteConfirmationOpen: toggleDeleteConfirmation
                            } }/>

                    }
                />
                <Route
                    path={ '/quiz/:quizID' }
                    render={ ( routeProps ) => <QuizPageAsync props={ {
                        route: route, ...routeProps,
                        handleOpenTemplateWizard: toggleTemplateWizard
                    } }/>
                    }/>

                <Route
                    path={ '/person/:quizID' }
                    render={ ( routeProps ) => <QuizPageAsync props={ {
                        route: route, ...routeProps,
                        handleOpenTemplateWizard: toggleTemplateWizard
                    } }/>
                    }/>
                <Route
                    path={ '/academy/:quizID' }
                    render={ ( routeProps ) => <QuizPageAsync props={ {
                        route: route, ...routeProps,
                        handleOpenTemplateWizard: toggleTemplateWizard
                    } }/>
                    }/>

                <Route
                    path='/calendar/:calendarID'
                       render={ ( routeProps ) => <CalendarPageAsync props={ {
                           route: route, ...routeProps,
                           handleOpenTemplateWizard: toggleTemplateWizard
                       } }/> }/>

                <Route
                    exact
                    path='/settings/profile'
                    render={(routeProps) => <SettingAsync props={{
                        route: route, ...routeProps,
                    }} />
                    } >
                </Route>

                <Route
                    exact
                    path='/settings/security'
                    render={(routeProps) => <SettingAsync props={{
                        route: route, ...routeProps,
                    }} />
                    } >
                </Route>

                <Route
                    exact
                    path='/settings/teams'
                    render={(routeProps) => <SettingAsync props={{
                        route: route, ...routeProps,
                    }} />
                    } >
                    {profile.permissions && !profile.permissions.includes('user_view') && <Redirect to='/404' />}
                </Route>

                <Route
                    exact
                    path='/settings/permissions'
                    render={(routeProps) => <SettingAsync props={{
                        route: route, ...routeProps
                    }} />
                    } >
                    {AuthenticatedRoute(profile.permissions, 'permission_edit')}
                </Route>

                <Route
                    exact
                    path='/settings/data-management'
                    render={(routeProps) => <SettingAsync props={{
                        route: route, ...routeProps
                    }} />
                    } >
                    {AuthenticatedRoute(profile.permissions, 'data_management')}
                </Route>

                <Redirect from='/dashboard/*' to='/404'/>
                <Redirect from={ `/${ quizType }/:quizID/editor/*` } to='/404'/>
                <Redirect from={ `/${ quizType  }/:quizID/*` } to='/404'/>
                <Redirect from='/settings/profile/*' to='/404' />
                <Redirect from='/settings/security/*' to='/404' />
                <Redirect from='/settings/teams/*' to='/404' />
                <Redirect from='/settings/permissions/*' to='/404' />
                <Redirect from='/settings/data-management/*' to='/404' />

            </Switch>
            {/*<DeleteUserDataForm />*/}
            { templateWizardOpened &&
            <TemplateWizard handleToggleTemplateWizard={ toggleTemplateWizard }/>
            }
            { duplicatePopupOpened &&
            <DuplicatePopup type={ quizType } elID={ duplicatingEl }
                            handleToggleDuplicatePopup={ toggleDuplicatePopup }/>
            }
            { deleteConfirmationOpened &&
            <Popup
                handleClose={ toggleDeleteConfirmation }
                windowStyle={ {
                    height: '190px',
                    width: '490px',
                    padding: '40px 20px',
                    borderRadius: '0.5rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 0.5rem 6.4rem 0 rgba(0, 0, 0, 0.24)'
                } }
            >
                <p className={ styles.popupTitle }>{ content.dashboard.do_you_want_delete } quiz?</p>
                <div className={ styles.buttonBox }>
                    <button className={ styles.button } onClick={ toggleDeleteConfirmation }>
                        { content.dashboard.cancel }
                    </button>
                    <button className={ styles.button } onClick={ deleteQuizHandle }>
                        { content.dashboard.delete }
                    </button>
                </div>
            </Popup>
            }

        </div>
        </PermissionProvider>
    );

} ;

export default MainPage;